import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "../features/api/apiSlice";
import { isTokenExpired } from "../services/tokenUtils";

const unauthorizedAccess = (store) => {
  let isUnauthorized = false;

  return (next) => (action) => {
    // Handle 401 errors from RTK Query
    if (action?.error && action?.payload?.status === 401 && !isUnauthorized) {
      const justLoggedIn = sessionStorage.getItem("justLoggedIn");
      if (justLoggedIn) {
        // Skip auto logout during fresh login
        return next(action);
      }

      // Prevent multiple triggers
      isUnauthorized = true;

      // Check if token is truly expired
      if (isTokenExpired()) {
        const currentPath = window.location.pathname + window.location.search;

        sessionStorage.setItem("redirectPath", currentPath);
        sessionStorage.setItem("autoLogout", "true");
        sessionStorage.setItem("unauthorized", "true");

        // Clear localStorage
        localStorage.clear();

        // Reset API state
        store.dispatch(apiSlice.util.resetApiState());

        // Go to login page
        window.location.href = "/login";
      } else {
        // Token not expired: allow next action
        isUnauthorized = false;
      }
    }

    return next(action);
  };
};

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware).concat(unauthorizedAccess),
});